import Vue from 'vue'
import Vuex from 'vuex'

export default class {
    constructor() {
        Vue.use(Vuex);
        const state = {};
        const getters = {};
        const mutations = {};
        const actions = {};

        this.store = new Vuex.Store({
            state: {
                selectedPageIndex: 0,
                searchQuery: {
                    searchTerm: "",
                    facets: [],
                    filters: [],
                    currentPage: 0,
                    pageSize: 20,
                    searchIndex: "",
                    filterGroups: "",
                    showContentType: false,
                    sortByAlpha: "All",
                    sortBy: "Relevance",
                    extended: {}
                },
                results: {
                    queryUsed: {},
                    itemResults: [],
                    filters: [],
                    totalResultCount: 0,
                    currentPage: 0,
                    pageSize: 0,
                    totalPages: 0
                },
                settings: {
                    searchUrl: "",
                    headerText: "Search Results",
                    searchPlaceholder: "Enter search terms",
                    searchButtonText: "Submit your search",
                    filterText: "Refine Results",
                    filterButtonText: "Apply Filters",
                    noResultsText: "No results found",
                    showContentType: false,
                    showSearchBox: false,
                    showCategories: false,
                    showFilterButton: true,
                    showSortByAlpha: false,
                    stackedRail: false,
                    horizontalFilters: false,
                    searchBoxPlacement: "content",
                    resultsType: 'search'
                }
            },
            getters,
            mutations : {
				setQuery(state, searchTerm) {
					state.searchQuery.searchTerm = searchTerm;
				},
				setPageIndex(state, data) {
					state.searchQuery.currentPage = parseInt(data);
				},
				setFilters(state, data) {
					state.searchQuery.filters = data;
                },
                setFilterGroups(state, data) {
					state.searchQuery.filterGroups = data;
                },
                setShowCategories(state, data) {
					state.settings.showCategories = Boolean(data);
				},
                setShowContentType(state, data) {
					state.settings.showContentType = Boolean(data);
					state.searchQuery.showContentType = Boolean(data);
				},
                setShowSearchBox(state, data) {
					state.settings.showSearchBox = Boolean(data);
				},
				setResults(state, results) {
					state.results = results;
				},
				setPageSize(state, size) {
					state.searchQuery.pageSize = parseInt(size);
				},
				setSearchIndex(state, index) {
					state.searchQuery.searchIndex = index;
                },
                setSettings(state, settings) {
                    state.settings = settings;
                },
                setSearchUrl(state, data) {
                    state.settings.searchUrl = data;
                },
                setSearchSortBy(state, data){
					state.searchQuery.sortBy = data;
                },
                setResultsType(state, data){
                    state.settings.resultsType = data;
                },
                setShowSortByAlpha(state, data){
                    state.settings.sortByAlpha = data;
                },
                setSortByAlpha(state, data){
                    state.searchQuery.sortByAlpha = data;
                }
			},
            actions
        });
    }
}